import { readable_reward } from "../../generated/models/readable_reward";
import isOfferExpired from "./isOfferExpired";
import isSpecialCoupon from "./isSpecialCoupon";
import is10PercentOffCoupon from "./is10PercentOffCoupon";
import isCouponOutOfRange from "./isCouponOutOfRange";

/**
 * Filters basket items to include only valid offers.
 * Removes:
 * - Items without offers
 * - Expired offers
 * - Special/10% off coupons that are out of range
 *
 * @param basketItems - Array of basket items to filter
 * @returns Filtered array of valid basket items
 */
export default function filterValidBasketItems(
  basketItems: readonly readable_reward[],
  now: Date,
): readable_reward[] {
  return basketItems.filter((r) => {
    if (!r.offer) return false;

    const offerEndDate = r.offer.ended_at ? new Date(r.offer.ended_at) : now;
    const expiryDate = r.actual_expired_at
      ? new Date(r.actual_expired_at)
      : offerEndDate;
    const isExpired = isOfferExpired(expiryDate, now);

    // Exclude special/10% off coupons that are out of range
    if (
      (isSpecialCoupon(r.offer) || is10PercentOffCoupon(r.offer)) &&
      isCouponOutOfRange(r.offer, now)
    ) {
      return false;
    }

    // Include if not expired
    return !isExpired;
  });
}
